var React = require('react');

function CrossBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.53711 13.2295H21.8706M12.4403 3.79907L12.4403 22.1326","stroke":"#1A8E96","strokeWidth":"6.11118","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CrossBig.defaultProps = {"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"};

module.exports = CrossBig;

CrossBig.default = CrossBig;
